var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThinArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 11,
    viewBox: "0 0 30 11",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 2,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(23.689982, 5.500000) rotate(-45.000000) translate(-23.689982, -5.500000) ",
    d: "M27.1899818 2L26.9750696 8.78508772 20.1899818 9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6397293 5.66514669L0 5.66514669"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThinArrow);
export default __webpack_public_path__ + "static/media/thin-arrow.5a279220b6cebbe66423fa3496a89f91.svg";
export { ForwardRef as ReactComponent };